import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getLookbook({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.get, id, signal });

    onSuccess && onSuccess(data.result);
    yield put(actions.getLookbookDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLookbookFailed,
      endpoint: api.lookbooks.get.url
    });
  }
}

export const getLookbookSaga = takeEvery(types.GET_LOOKBOOK_REQUEST, getLookbook);